import { Grid, Card, CardBody } from '@backstage/ui';
import {
  SearchBar,
  SearchTypeFilter,
  SearchFilters,
  SearchResultList,
} from './components';
import styles from './search.page.module.css';

const SearchPage = () => {
  return (
    <Grid.Root columns="12" gap="4">
      {/* Search bar — full width */}
      <Grid.Item colSpan="12">
        <Card>
          <CardBody>
            {/* eslint-disable-next-line jsx-a11y/no-autofocus */}
            <SearchBar autoFocus />
          </CardBody>
        </Card>
      </Grid.Item>

      {/* Sidebar: type filter + filters */}
      <Grid.Item colSpan={{ xs: '12', md: '3' }}>
        <Card>
          <CardBody>
            <SearchTypeFilter />
          </CardBody>
        </Card>
        <Card className={styles.filterCardGap}>
          <CardBody>
            <SearchFilters />
          </CardBody>
        </Card>
      </Grid.Item>

      {/* Main: results */}
      <Grid.Item colSpan={{ xs: '12', md: '9' }}>
        <SearchResultList />
      </Grid.Item>
    </Grid.Root>
  );
};

export default SearchPage;
